export enum RecommendPlacementId {
  HOMEPAGE_EXTERNAL = 'homepage_external',
  ARTICLE_DETAIL_RELATED = 'article_detail_related',
  ARTICLE_DETAIL_EXTERNAL = 'article_detail_external',
  SECTION_EXTERNAL = 'section_external',
}